import { Badge, Box, Text } from '@mantine/core'

import { Product as ProductType } from '@/types'

import PriceDefault from './PriceDefault'
import PriceVariation from './PriceVariation'

interface Props {
  product: ProductType
}

function PriceLabel({ product }: Props) {
  const { hasKit, hasStock, price, priceRange, priceKit, structure } = product
  return (
    <Box>
      {!hasStock && (
        <Badge color="red" mb="sm">
          Sem estoque
        </Badge>
      )}
      {hasKit && !priceKit ? (
        <Text>Consultar</Text>
      ) : (
        <PriceDefault price={structure === 'standalone' && priceKit ? priceKit : price} />
      )}
      {structure === 'parent' && priceRange?.lowest && <PriceVariation priceRange={priceRange} />}
    </Box>
  )
}

export default PriceLabel
